import ADMIN_CREATE_SECTION_TABS from '../../models/adminCreateSectionTabs';
import ROLES from '../../models/roles';

class AdminCreateSectionController {
  constructor($stateParams, $state, localStorageService) {
    this.name = 'adminCreateSection';
    this.$state = $state;
    this.localStorageService = localStorageService;
    this.activateTab($stateParams.tabName);
  }


  activateTab(tabName) {
    let activeTabProperty = ADMIN_CREATE_SECTION_TABS[tabName].activeTabProperty;
    this[activeTabProperty] = true;
  }

  setActiveTabFromClick(tabName) {
    this.activateTab(tabName);
    this.$state.go(this.$state.current, {
      tabName: tabName
    }, {
      notify: false,
      reload: this.$state.current
    });
  }

  isSuperAdmin() {
    return parseInt(this.localStorageService.get('role')) === ROLES.SUPER_ADMIN;
  }
}

AdminCreateSectionController.$inject = ['$stateParams', '$state', 'localStorageService'];

export default AdminCreateSectionController;


// WEBPACK FOOTER //
// ./app/components/adminCreateSection/adminCreateSection.controller.js